import React, { useEffect, useRef, useState } from "react";
import AddNewField from "./AddNewField";
import { CommonUtil } from "../../utils/CommonUtil";
import { NetworkManager } from "../../Components/NetworkManager";
import ToastManager from "../../Components/ToastManager";
import Confirm from "../../Components/confirm";
import CreatableSelect from "react-select/creatable";
import SelectField from "../../Components/SelectField";
import InputField from "../../Components/InputField";
import CreatableReactSelect from "../../Components/CreatableReactSelect";
import ToggleSwitch from "../../Components/ToggleSwitch";
let deletedItem: any = null;
const DocumentCreation = ({ unSavedChanges }: any) => {
  const sassOrgId = CommonUtil.getSaasOrgId();
  const [documents, setDocuments] = useState<any>([]);
  const [selectedDocType, setSelectedDocType] = useState<any>({
    id: "",
    name: "",
  });
  const [fields, setFields] = useState<any>([]);
  const [mandatoryFields, setMandatoryFields] = useState<any>([]);
  const [optionalFields, setOptionalFields] = useState<any>([]);
  const [hoveredMandatoryIndex, setHoveredMandatoryIndex] = useState<number | null>(null);
  const [hoveredOptionalIndex, setHoveredOptionalIndex] = useState<number | null>(null);
  const [isPictureState, setIsPictureState] = useState<{[key: number]: boolean;}>({});
  const [tempFields, setTempFields] = useState<any>([]);
  const [allDocFields, setAllDocFields] = useState<any>([]);
  const [unSaved, setUnSaved] = useState<boolean>(false);
  const [editIndex, setEditIndex] = useState<{ [key: number]: boolean }>({});
  const [fieldValue, setFieldValue] = useState<any>([]);
  const [draggedItem, setDraggedItem] = useState<any>(null);
  const [isDependent, setIsDependent] = useState<boolean>(false);
  const [dependentFieldData, setDependentFieldData] = useState<string>("");
  const [dependentField, setSealNumber] = useState<string>("");
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [ isInvalid, setIsInvalid] = useState(false);

  useEffect(() => {
    getAllDocumentTypes();
  }, []);
  
  useEffect(() => {
    const isDifferent =
      JSON.stringify(tempFields) !== JSON.stringify(allDocFields);
    setUnSaved(isDifferent);
    unSavedChanges(isDifferent);
  }, [tempFields, allDocFields]);

  useEffect(() => {
    if (selectedDocType.id !== "") {
      setIsPictureState({});
      getMasterFields();
      getAllDocFields();
    }
  }, [selectedDocType]);

  useEffect(() => {
    const mandatory = tempFields.filter((field: any) => field.isMandatory);
    const optional = tempFields.filter((field: any) => !field.isMandatory);
    setMandatoryFields(mandatory);
    setOptionalFields(optional);

  console.log("tempFields", tempFields);
  }, [isPictureState, tempFields]);

  const onLoginError = (err: any) => {
    console.log(err);
  };

  const getAllDocumentTypes=()=>{
    const orgUrl=`api/v2/config/document-types/all/?orgId=${sassOrgId}`;
    NetworkManager.sendJsonRequest(orgUrl,"","","GET",true,onGetAllDocTypes,onLoginError)
  };

  const onGetAllDocTypes = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && restData.length > 0) {
        setDocuments(restData);
      } else {
        setDocuments([]);
      }
    }
  };

  const getMasterFields=()=>{
    const orgUrl="api/v2/config/document-field/master-fields";
    NetworkManager.sendJsonRequest(orgUrl,"","","GET",true,onGetMasterFields,onLoginError)
  };

  const onGetMasterFields = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && restData.length > 0) {
        setFields(restData);
      } else {
        setFields([]);
      }
    }
  };

  const getAllDocFields=()=>{
    const orgUrl=`api/v2/config/document-field/all/?orgId=${sassOrgId}&docTypeId=${parseInt(selectedDocType.id)}`;
    NetworkManager.sendJsonRequest(orgUrl,"","","GET",true,onGetAllDocFields,onLoginError)
  };

  const onGetAllDocFields = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (restData && restData.length > 0) {
        const updatedData = restData.map((fields: any) => ({
          ...fields,
          fieldTypeValue: fields.fieldType === "Dropdown" && fields.fieldTypeValue?.length > 0 ? fields.fieldTypeValue.map((item: any) => {
            return { label: item, value: item };
          }) : null,
        }));
        setAllDocFields(updatedData);
        setTempFields(updatedData);
      } else {
        setAllDocFields([]);
        setTempFields([]);
      }
    }
  };

  const handleDocType = (event: any) => {
    const selectedId = event.target.value;
    const selectedOption = event.target.options[event.target.selectedIndex];
    const selectedName = selectedOption.getAttribute("data-name") || "";
    setSelectedDocType({ id: selectedId, name: selectedName });
    setEditIndex({});
    setFieldValue([]);
  };

  const handleDelete = (item?: any) => {
    deletedItem = item?.fieldName;
    Confirm.show("Confirm", `${unSaved ? "You have unsaved changes. Do you want to discard them and Delete this Process?" : "Would you like to delete this Document Field?"}`, [
      {
        label: "Yes",
        callback: function () {
          if (item?.fieldId) {
            let docTypeDelAPI = `api/v2/config/document-field/${item?.fieldId}?orgId=${sassOrgId}`;
            NetworkManager.sendJsonRequest(docTypeDelAPI, "", "", "DELETE", true, onDeleteSuccess, onLoginError);
          } else {
            setTempFields((prevTempFields: any) => {
              const filteredFields = prevTempFields.filter((field: any) => field.fieldName !== item?.fieldName);
              return filteredFields.map((field:any, index:any) => ({ ...field, sequenceId: index + 1 }));
            });
            ToastManager.showToast("Field Removed", "Info");
          }
        },
      },
      { label: "No" },
    ]);
  };

  const onDeleteSuccess = (dataObj: any) => {
    if (dataObj) {
      var restData = CommonUtil.parseData(dataObj);
      if (!restData.errorMessage) {
        setTempFields((prevTempFields: any) => {
          const filteredFields = prevTempFields.filter((field: any) => field.fieldName !== deletedItem);
          return filteredFields.map((field:any, index:any) => ({ ...field, sequenceId: index + 1 }));
        });
        ToastManager.showToast("Field Deleted Successfully", "Info");
        deletedItem = null;
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
      getAllDocFields();
    }
  };
  
  const handleSelect = (column: "mandatory" | "optional", masterFieldId: number, item?:any) => {
    const fieldObject = fields.find((field: any) => field.masterFieldId === masterFieldId);
    if (!fieldObject) return;
  
    setTempFields((prevFields: any) => {
      let updatedFields = [...prevFields];
      const existingIndex = updatedFields.findIndex((field: any) => field.sequenceId === item?.sequenceId);
      
      if (existingIndex !== -1) {
        updatedFields[existingIndex] = {
          ...updatedFields[existingIndex],
          fieldName: fieldObject.fieldName,
          masterFieldId: fieldObject.masterFieldId,
        };
      } else {
        updatedFields = [
          ...updatedFields,
          {
            ...fieldObject,
            isMandatory: column === "mandatory",
            sequenceId: updatedFields.length + 1,
            pictureRequired: item?.pictureRequired,
          }
        ];
      }
  
      return [...updatedFields].map((field, idx) => ({...field, sequenceId: idx + 1 }));
    });
  };


  const availableOptions = (column: "mandatory" | "optional", index: number) => {
    const selectedFields = tempFields.map((field:any) => field.masterFieldId);

    return fields.filter((field: any) =>
        !selectedFields.includes(field.masterFieldId) ||
        field.masterFieldId === (column === "mandatory" ? mandatoryFields[index]?.masterFieldId : optionalFields[index]?.masterFieldId)
    );
  };

  const getNewField = (newField: any) => {
    console.log(newField, "newField");
  
    if (newField?.fieldType === "Existing" && newField?.masterFieldId) {
      handleSelect(
        newField?.isMandatory === true ? "mandatory" : "optional",
        parseInt(newField?.masterFieldId),
        newField,
      );
      return; 
    }
  
    const nameExists = tempFields.some(
      (doc: any) =>
        doc.fieldName?.trim().toLowerCase() ===
        newField.fieldName?.trim().toLowerCase()
    );
  
    if (nameExists) {
      ToastManager.showToast("Field Name already exists!", "Error");
      return;
    }
  
    setTempFields((prevFields: any) => {
      const updatedFields = [
        ...prevFields,
        {
          ...newField,
          fieldTypeValue:
            newField.fieldType === "Dropdown" &&
            newField.fieldTypeValue?.length > 0
              ? newField.fieldTypeValue
              : null,
          sequenceId: prevFields.length + 1,
        },
      ];
  
      return updatedFields.map((field, index) => ({
        ...field,
        sequenceId: index + 1,
      }));
    });
  };
  

  const availableOptionsCount = fields.filter(
    (field: any) => ![...mandatoryFields, ...optionalFields].some((selectedField: any) =>
          selectedField.masterFieldId === field.masterFieldId)).length;

  const availableExistingOptions = fields.filter(
    (field: any) => ![...mandatoryFields, ...optionalFields].some((selectedField: any) =>
          selectedField.masterFieldId === field.masterFieldId));
  
  const handleEdit = (item: any) => {
    setEditIndex({ [item.sequenceId]: true });
    setFieldValue({ ...item });
    setIsDependent(item.isDependent);
    setDependentFieldData(item.dependentFieldData || "");
    setSealNumber(item.dependentField || "");
  };
    
  
  const onHandleEditField = (e: any) => {
    const { value } = e.target;
    setFieldValue((prev: any) => ({
      ...prev,
      fieldName: value,
    }));
  };

  const onEditFieldTypeValue = (options: any) => {
    setFieldValue((prev: any) => ({
      ...prev,
      fieldTypeValue: options,
    }));
  };


  const handleEditSave = () => {
    setTempFields((prevFields: any) =>
      prevFields.map((field: any) =>
        field.sequenceId === fieldValue.sequenceId ? 
        { ...field, 
          fieldName: fieldValue.fieldName,
          fieldTypeValue: fieldValue.fieldType === "Dropdown" && fieldValue.fieldTypeValue?.length > 0 ? fieldValue.fieldTypeValue : null,
          isDependent: isDependent,
          dependentFieldData: dependentFieldData,
          dependentField: dependentField,
          sequenceId: fieldValue.sequenceId 
        } : field
      )
    );
    setEditIndex({});
  };

  const handleEditClose = (item:any) => {
    setEditIndex({});
    setIsDependent(false);
    setDependentFieldData("");
    setSealNumber("");
  }

  const onPictureToggle = (sequenceId: number) => {
    setIsPictureState((prevState) => {
      const prevValue = prevState.hasOwnProperty(sequenceId)
        ? prevState[sequenceId]
        : tempFields.find((field: any) => field.sequenceId === sequenceId)?.pictureRequired || false;
  
      const newState = { ...prevState, [sequenceId]: !prevValue };
  
      setTempFields((prevFields: any) =>
        prevFields.map((field: any) =>
          field.sequenceId === sequenceId
            ? { ...field, pictureRequired: newState[sequenceId] }
            : field
        )
      );
      return newState;
    });
  };

  useEffect(() => {
  const isDependentInvalid =
    isDependent === true && (dependentFieldData === "" || dependentField === "");

  const isDropdownInvalid =
    fieldValue.fieldType === "Dropdown" &&
    fieldValue.fieldTypeValue?.length === 0;

  const isFieldName = fieldValue.fieldName?.trim() === "";

  setIsInvalid(isDependentInvalid || isDropdownInvalid || isFieldName);
}, [isDependent, dependentFieldData, dependentField, fieldValue]);

  
  useEffect(() => {
    const availableOptions = fieldValue?.fieldTypeValue || [];
    const dependentValue: any = fieldValue?.dependentFieldData;
    const isDependentStillValid = availableOptions.some(
      (option: any) => option.value === dependentValue
    );
    if (!isDependentStillValid) {
      setDependentFieldData("");
    }
    
  }, [fieldValue.fieldTypeValue, fieldValue.dependentFieldData]);

  const handleSave = () => {

    const payload = tempFields.map((fieldData:any) => {
      return {
        documentTypesName: selectedDocType.name || "string",
        documentTypesId: selectedDocType.id || 0,
        fieldName: fieldData.fieldName || null,
        fieldId: fieldData.fieldId || null,
        fieldType: fieldData.fieldType || "Text",
        fieldTypeValue: fieldData.fieldTypeValue?.map((type: any) => type.value) || null,
        inspectionOrgId: sassOrgId,
        isDependent: fieldData.isDependent || false,
        dependentFieldData: fieldData.dependentFieldData || null,
        isLoaded: false,
        isMandatory: fieldData.isMandatory || false,
        masterFieldId: fieldData.masterFieldId || null,
        pictureRequired: fieldData?.pictureRequired || false,
        saasOrgId: sassOrgId,
        dependentField: fieldData.dependentField || null, 
        sequenceId: fieldData.sequenceId
      };
    });

    console.log("Saved Data:", payload);
    const url = `api/v2/config/document-field/bulk/?orgId=${sassOrgId}`;
    NetworkManager.sendJsonRequest(url, payload, "", "POST", true, onSaveSuccess, onLoginError);
  };

  const onSaveSuccess = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (!restData.errorMessage) {
        ToastManager.showToast("Document Fields Created Successfully", "Info");
        setEditIndex({});
        getAllDocFields();
        setIsPictureState({});
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
    }
  };
    
  const handleDragStart = (event: any, item: any) => {
    setDraggedItem(item);
    event.dataTransfer.effectAllowed = "move";
  };
  
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  
  const handleDrop = (event: any, targetItem: any) => {
    event.preventDefault();
    if (
      !draggedItem ||
      draggedItem.fieldId === targetItem.fieldId
    )
      return;

    const updatedList = tempFields
      .map((item: any) => {
        if (typeof item.sequenceId === "undefined") {
          return { ...item, sequenceId: tempFields.length + 1 };
        }
        return item;
      })
      .map((item: any) => {
        if (item.fieldId === draggedItem.fieldId)
          return { ...item, sequenceId: targetItem.sequenceId };

        if (
          draggedItem.sequenceId < targetItem.sequenceId &&
          item.sequenceId > draggedItem.sequenceId &&
          item.sequenceId <= targetItem.sequenceId
        ) {
          return { ...item, sequenceId: item.sequenceId - 1 };
        }
        if (
          draggedItem.sequenceId > targetItem.sequenceId &&
          item.sequenceId < draggedItem.sequenceId &&
          item.sequenceId >= targetItem.sequenceId
        ) {
          return { ...item, sequenceId: item.sequenceId + 1 };
        }
        return item;
      })
      .sort((a: any, b: any) => a.sequenceId - b.sequenceId);

    setTempFields(updatedList);
    setDraggedItem(null);
    updateSequenceAPI(updatedList);
  };
  
  const updateSequenceAPI = async (updatedList: any) => {
    console.log(updatedList, "updatedList");
    const payload = updatedList.map((item: any, index: any) => ({
      fieldName: item.fieldName,
      fieldId: item.fieldId,
      sequenceId: index + 1,
    }));
    const url = `api/v2/config/document-field/sequence?orgId=${sassOrgId}`;
    NetworkManager.sendJsonRequest(url, payload, "", "POST", true, onUpdateSequence, onLoginError);
  };
  
  const onUpdateSequence = (dataObj: any) => {
    if (dataObj) {
      const restData = JSON.parse(dataObj);
      if (!restData.errorMessage) {
        ToastManager.showToast("Sequence Updated Successfully", "Info");
      }else{
        ToastManager.showToast(restData.errorMessage, "Error");
      }
      getAllDocFields();
    }
  };
  
  return (
    <div>
      <form>
        <div className="col-12 row d-flex align-items-center mb-40">
          <div className={`col-lg-11 rounded bg-light`}>
            <div className={`d-flex p-3 ${documents.length > 0 ? "d-none" : ""}`}>
              <span>
                <i className="fa fa-info-circle me-3 icon-muted"></i>
              </span>
              <div className="fw-400 text-muted">
                <span className="fw-600 text-dark">No Document type added yet</span>
                <br></br>
                Add a document type from the previous screen 
              </div>
            </div>
          </div>
          <div className={`form-group col-md-4 mb-0 ps-4 ${documents.length > 0 ? "" : "d-none"}`}>
            <SelectField 
              placeholder="Select Document Type"
              className="form-select"
              id="exampleFormControlSelect2"
              value={selectedDocType.id}
              onChange={handleDocType}
              disabled={unSaved}
              infoText="Type: Dropdown, Select option from dropdown"
            >
              <option value="" disabled>Select Document Type</option>
              {documents.map((option: any) => (
                <option key={option.documentTypesId} value={option.documentTypesId} data-name={option.documentTypesName}>
                  {option.documentTypesName}
                </option>
              ))}
            </SelectField>
          </div>
          <div className={`col-md-8 ${selectedDocType.id === "" ? "d-none" : ""} `} style={{ textAlign: "right" }}>
            <AddNewField getNewField={getNewField} availableOptions={availableExistingOptions} isExisting={true} />
            <button type="button" className="btn btn-dark ms-2" onClick={handleSave} 
              disabled={!unSaved || isInvalid || Object.keys(editIndex).length > 0}>Save</button>
          </div>
        </div>
        <div className={`d-flex align-items-start mt-4 ${selectedDocType.id === "" ? "d-none" : ""}`} style={{overflowY: "auto", overflowX: "hidden", height:`${window.innerHeight - 220}px`,paddingRight:"12px"}}>
          <div className="col-6 border-right pe-3">
            <div className="d-flex justify-content-between align-items-center">
            <div><h5 className="heading ps-3">Mandatory Fields</h5></div>
            </div>
            <div className="mandatory">
              <div className="d-flex align-items-center mt-4 ps-3">
                <div className="field">
                  <h6 className="sub-heading">Fields</h6>
                </div>
                <div className="d-flex align-items-center mx-1 image">
                  <h6 className="sub-heading">Image</h6>
                  <a className="ms-1 align-self-center">
                    <img className=" pe-auto mb-2" 
                    src={ "./../images/info.svg"} alt="info" width={16} height={16}
                    title="Enable to add an image for this field."/>
                  </a>
                </div>
              </div>
              {tempFields.filter((field: any) => field.isMandatory).map((item: any, index: any) => (
                <div
                  key={index}
                  draggable={unSaved || editIndex[item.sequenceId] ? false : true}
                  onDragStart={(event) => handleDragStart(event, item)}
                  onDragOver={handleDragOver}
                  onDrop={(event) => handleDrop(event, item)}
                  className={`d-flex align-items-center mt-4 ${unSaved ? "ms-3" : "drag-icon"} ${editIndex[item.sequenceId] ? "w-full sh p-3" : ""}`}
                  onMouseOver={() => setHoveredMandatoryIndex(index)}
                  onMouseOut={() => setHoveredMandatoryIndex(null)} 
                  title={`Click, Hold, and Drag to set the right sequence`}>
                  <div className={`field`}
                    title={`Type - ${item.fieldType && !item.masterFieldId ? String(item.fieldType).charAt(0).toUpperCase() + String(item.fieldType).slice(1) : "Existing Field"}`}
                  >
                    {item?.masterFieldId ? (
                      <InputField
                          placeholder={`${item.fieldType && !item.masterFieldId ? String(item.fieldType).charAt(0).toUpperCase() + String(item.fieldType).slice(1) : "Existing"} Field`} 
                          type="text"
                          className="form-control"
                          value={item.fieldName}
                          disabled
                          onChange={(e:any) => handleSelect("mandatory", parseInt(e.target.value), item)}

                        />
                    ) : (<InputField
                          placeholder={`${item.fieldType && !item.masterFieldId ? String(item.fieldType).charAt(0).toUpperCase() + String(item.fieldType).slice(1) : "Existing"} Field`}
                          type="text"
                          className="form-control"
                          value={editIndex[item.sequenceId] ? fieldValue?.fieldName : item.fieldName}
                          disabled={!editIndex[item.sequenceId]}
                          onChange={(e:any)=>onHandleEditField(e)}
                          infoText="Type: Text, Enter Alphanumeric values"
                        />)}
                    {item.fieldType === "Dropdown" && item.fieldTypeValue?.length > 0 && ( 
                      <>{!editIndex[item.sequenceId] ?
                        <div className="ms-1 d-flex justify-content-start">
                          <small className="fst-italic ms-1">Options<img className="ms-1" title={item?.fieldTypeValue?.map((item:any) => item.label).join(', ')} src={ "./../images/info.svg"} alt="info" width={12} height={12}/></small>
                          {(item?.isDependent || isDependent) && <><small className="fst-italic mx-3">Dependent Data<img className="ms-1" title={item?.dependentFieldData} src={ "./../images/info.svg"} alt="info" width={12} height={12}/></small>
                          <small className="fst-italic">Dependent Field<img className="ms-1" title={item?.dependentField} src={ "./../images/info.svg"} alt="info" width={12} height={12}/></small></>}
                        </div>:
                        <div className="my-3">
                          <CreatableReactSelect
                          isMulti
                          options={[]}
                          value={editIndex[item.sequenceId] ? fieldValue?.fieldTypeValue : item.fieldTypeValue}
                          onChange={(selected:any) => onEditFieldTypeValue(selected)}
                          isDisabled={!editIndex[item.sequenceId]}
                          placeholder={"Create options..."}
                          infoText="Type: Dropdown, Press enter to add new options"
                        />
                        {isInvalid && fieldValue?.fieldTypeValue?.length ===0 && <small className="ms-2 text-danger fst-italic">Dropdown Options are required</small>}
                        <small className="ms-2 fst-italic">Press enter to add new option</small>
                        
                        <div className="my-3 mx-2 align-items-center">
                          <ToggleSwitch name="isDependent" 
                            checked={editIndex[item.sequenceId] ? isDependent : item.isDependent}
                            onChange={() => setIsDependent(!isDependent)}
                            label="Dependent field required?"
                          />
                        </div>
                        {(item?.fieldType === "Dropdown" && (editIndex[item.sequenceId] ? isDependent : item?.isDependent)) && 
                          <><div className="d-flex align-item-center ms-2 mb-4">
                            <div className="col-md-10 ms-2">
                              <SelectField
                                name="dependentFieldData"
                                placeholder="Dependent Field Data"
                                value={editIndex[item.sequenceId] ? dependentFieldData : item?.dependentFieldData}
                                onChange={(e:any) => setDependentFieldData(e.target.value)}
                                infoText="Type: Dropdown, Select option from dropdown"
                              >
                                <option value="" disabled>Select</option>
                                {fieldValue?.fieldTypeValue?.map((field: any, index: any) => (
                                  <option key={index} value={field?.value}>
                                    {field.label}
                                  </option>
                                ))}
                              </SelectField>
                            </div>
                          </div>
                          <div className="d-flex align-item-center ms-2">
                            <div className="col-md-10 ms-2">
                              <InputField
                                type="text"
                                name="dependentField"
                                style={{ height: "35px" }}
                                className="form-control"
                                placeholder="Dependent Field Name"
                                value={editIndex[item.sequenceId] ? dependentField : item?.dependentField}
                                onChange={(e:any) => setSealNumber(e.target.value)}
                                infoText="Type: Text, Enter Alphanumeric values"
                              />
                              <small className="ms-2 fst-italic">as Text Field</small>
                            </div>
                          </div>
                          {isInvalid && <small className="ms-2 text-danger fst-italic">Dependent Fields are required</small>}</>}
                        </div>
                    }</>)}
                  </div>
                  <div className="d-flex align-items-center">
                    <div className={`input ${editIndex[item.sequenceId] ? "d-none" : ""}`}>
                      <label className="toggle">
                        <input
                          className="toggle-checkbox"
                          type="checkbox"
                          checked={
                            isPictureState.hasOwnProperty(item.sequenceId)
                              ? isPictureState[item.sequenceId]
                              : item.pictureRequired
                          }                          
                          onChange={() => onPictureToggle(item.sequenceId)}
                        />
                        <div className="toggle-switch"></div>
                      </label>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                    {!editIndex[item.sequenceId] ? (
                      <div
                        className="text-start d-flex align-items-center"
                        style={{
                          visibility: hoveredMandatoryIndex === index ? "visible" : "hidden",
                        }}
                      >
                        <button
                          className="ms-2 p-1 mb-2 cursor pointer border-0 bg-transparent"
                          onClick={(e) => {
                            e.preventDefault();
                            handleEdit(item)
                          }}
                          hidden={item.masterFieldId}
                          title="Edit"
                        >
                          <img src={"./../images/edit.svg"} alt="Edit" />
                        </button>
                        <button
                          className="ms-2 p-1 mb-2 cursor pointer border-0 bg-transparent"
                          onClick={(e) => {
                            e.preventDefault();
                            handleDelete(item)
                          }}
                          title="Delete"
                        >
                          <img src={"./../images/delete.svg"} alt="delete" />
                        </button>
                      </div>
                    ) : (
                      <div className="text-start d-flex align-items-center">
                        <button type="submit" className="ms-2 p-1 mb-2 cursor pointer border-0 bg-transparent"
                          style={isInvalid ? {cursor: "not-allowed"} : {cursor: "pointer"}} title="Save" disabled={isInvalid} 
                          onClick={(e) => {
                            e.preventDefault();
                            handleEditSave();
                          }}>
                          <img src={"./../images/check.svg"} alt="check" width={24} height={24} />
                        </button>
                        <button type="button" title="Close" className="ms-2 p-1 mb-2 cursor pointer border-0 bg-transparent" 
                          onClick={(e) => {
                              e.preventDefault();
                              handleEditClose(item);}} >
                          <img src={"./../images/cancel.svg"} alt="cancel" width={24} height={24} />
                        </button>
                      </div>
                    )}
                    </div>
                    
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-6 col ps-3 ps-2">
            <div className="d-flex justify-content-between align-items-center">
            <div>
            <h5 className="heading ps-3">Optional Fields</h5>
            </div>
          </div>

            <div className="mandatory">
              <div className="d-flex align-items-center mt-4 ps-3">
                <div className="field">
                  <h6 className="sub-heading">Fields</h6>
                </div>
                <div className="d-flex align-items-center mx-1 image">
                  <h6 className="sub-heading">Image</h6>
                  <a className="ms-1 align-self-center">
                    <img className=" pe-auto mb-2" 
                    src={ "./../images/info.svg"} alt="info" width={16} height={16}
                    title="Enable to add an image for this field."/>
                  </a>
                </div>
              </div>
              {tempFields.filter((field: any) => !field.isMandatory).map((item: any, index: any) => (
                <div
                  key={index}
                  draggable={unSaved || editIndex[item.sequenceId] ? false : true}
                  onDragStart={(event) => handleDragStart(event, item)}
                  onDragOver={handleDragOver}
                  onDrop={(event) => handleDrop(event, item)}
                  className={`d-flex align-items-center mt-4 ${unSaved ? "ms-3" : "drag-icon"} ${editIndex[item.sequenceId] ? "w-full sh p-3" : ""}`}
                  onMouseOver={() => setHoveredOptionalIndex(index)}
                  onMouseOut={() => setHoveredOptionalIndex(null)} 
                  title={`Click, Hold, and Drag to set the right sequence`}>
                  <div className="field"   
                    title={`Type - ${item.fieldType && !item.masterFieldId ? String(item.fieldType).charAt(0).toUpperCase() + String(item.fieldType).slice(1) : "Existing Field"}`}
                  >
                    {item.masterFieldId ? (
                      <InputField
                          placeholder={`${item.fieldType && !item.masterFieldId ? String(item.fieldType).charAt(0).toUpperCase() + String(item.fieldType).slice(1) : "Existing"} Field`} 
                          type="text"
                          className="form-control"
                          value={item.fieldName}
                          disabled
                          onChange={(e:any) => handleSelect("optional", parseInt(e.target.value), item)}
                          infoText="Type: Text, Enter Alphanumeric values"
                        />
                    ) : 
                    (
                      <InputField
                        placeholder={`${item.fieldType && !item.masterFieldId ? String(item.fieldType).charAt(0).toUpperCase() + String(item.fieldType).slice(1) : "Existing"} Field`}
                        type="text"
                        className="form-control"
                        value={editIndex[item.sequenceId] ? fieldValue?.fieldName : item.fieldName}
                        disabled={!editIndex[item.sequenceId]}
                        onChange={(e:any)=>onHandleEditField(e)}
                        infoText="Type: Text, Enter Alphanumeric values"
                      />
                    )}
                    {item.fieldType === "Dropdown" && item.fieldTypeValue?.length > 0 && ( 
                      <>{!editIndex[item.sequenceId] ?
                        <div className="ms-1 d-flex justify-content-start">
                          <small className="fst-italic ms-1">Options<img className="ms-1" title={item?.fieldTypeValue?.map((item:any) => item.label).join(', ')} src={ "./../images/info.svg"} alt="info" width={12} height={12}/></small>
                          {(item?.isDependent || isDependent) && <><small className="fst-italic mx-3">Dependent Data<img className="ms-1" title={item?.dependentFieldData} src={ "./../images/info.svg"} alt="info" width={12} height={12}/></small>
                          <small className="fst-italic">Dependent Field<img className="ms-1" title={item?.dependentField} src={ "./../images/info.svg"} alt="info" width={12} height={12}/></small></>}
                        </div>:
                        <div className="my-3 mt-4">
                          <CreatableReactSelect
                            isMulti
                            options={[]}
                            value={editIndex[item.sequenceId] ? fieldValue?.fieldTypeValue : item.fieldTypeValue}
                            onChange={(selected:any) => onEditFieldTypeValue(selected)}
                            isDisabled={!editIndex[item.sequenceId]}
                            placeholder={"Create options..."}
                            infoText="Type: Dropdown, Press enter to add new options"
                          />
                        {isInvalid && fieldValue?.fieldTypeValue?.length ===0 && <small className="ms-2 text-danger fst-italic">Dropdown Options are required</small>}
                        <small className="ms-2 fst-italic">Press enter to add new option</small>
                        <div className="my-3 mx-2 align-items-center">
                          <ToggleSwitch name="isDependent" 
                            checked={editIndex[item.sequenceId] ? isDependent : item.isDependent}
                            onChange={() => setIsDependent(!isDependent)}
                            label="Dependent field required?"
                          />
                        </div>
                        {(item?.fieldType === "Dropdown" && (editIndex[item.sequenceId] ? isDependent : item?.isDependent)) && 
                          <><div className="d-flex align-item-center ms-2 mb-4">
                            <div className="col-md-10 ms-2">
                              <SelectField
                                name="dependentFieldData"
                                placeholder="Dependent Field Data"
                                value={editIndex[item.sequenceId] ? dependentFieldData : item?.dependentFieldData}
                                onChange={(e:any) => setDependentFieldData(e.target.value)}
                                infoText="Type: Dropdown, Select option from dropdown"
                              >
                                <option value="" disabled>Select</option>
                                {fieldValue?.fieldTypeValue?.map((field: any, index: any) => (
                                  <option key={index} value={field?.value}>
                                    {field.label}
                                  </option>
                                ))}
                              </SelectField>
                            </div>
                          </div>
                          <div className="d-flex align-item-center ms-2">
                            <div className="col-md-10 ms-2">
                              <InputField
                                type="text"
                                name="dependentField"
                                style={{ height: "35px" }}
                                className="form-control"
                                placeholder="Dependent Field Name"
                                value={editIndex[item.sequenceId] ? dependentField : item?.dependentField}
                                onChange={(e:any) => setSealNumber(e.target.value)}
                                infoText="Type: Text, Enter Alphanumeric values"
                              />
                              <small className="ms-2 fst-italic">as Text Field</small>
                            </div>
                          </div>
                          {isInvalid && <small className="ms-2 text-danger fst-italic">Dependent Fields are required</small>}
                          </>}
                        </div>
                    }</>)}
                  </div>
                  <div className="d-flex align-items-center">
                    <div className={`input ${editIndex[item.sequenceId] ? "d-none" : ""}`}>
                      <label className="toggle">
                        <input
                          className="toggle-checkbox"
                          type="checkbox"
                          checked={
                            isPictureState.hasOwnProperty(item.sequenceId)
                              ? isPictureState[item.sequenceId]
                              : item.pictureRequired
                          }                          
                          onChange={() => onPictureToggle(item.sequenceId)}
                        />
                        <div className="toggle-switch"></div>
                      </label>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                    {!editIndex[item.sequenceId] ? (
                      <div
                        className={`text-start d-flex align-items-center`}
                        style={{
                          visibility: hoveredOptionalIndex === index ? "visible" : "hidden",
                        }}
                      >
                        <button
                          className={`ms-2 p-1 mb-2 cursor pointer border-0 bg-transparent`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleEdit(item)
                          }}
                          hidden={item.masterFieldId}
                          title="Edit"
                        >
                          <img src={"./../images/edit.svg"} alt="Edit" />
                        </button>
                        <button
                          className="ms-2 p-1 mb-2 cursor pointer"
                          style={{
                            border: "none",
                            background: "none",
                          }}
                          onClick={(e) => {
                            e.preventDefault();
                            handleDelete(item)
                          }}
                          title="Delete"
                        >
                          <img src={"./../images/delete.svg"} alt="delete" />
                        </button>
                      </div>
                    ) : (
                      <div className="text-start d-flex align-items-center">
                        <button type="button" className="ms-2 p-1 mb-2 cursor pointer border-0 bg-transparent"
                          style={isInvalid ? {cursor: "not-allowed"} : {cursor: "pointer"}} title="Save" disabled={isInvalid}
                        onClick={(e) => {
                            e.preventDefault();
                            handleEditSave();
                          }}>
                          <img src={"./../images/check.svg"} alt="check" width={24} height={24}/>
                        </button>
                        <button type="button" title="Close" className="ms-2 p-1 mb-2 cursor pointer border-0 bg-transparent" onClick={(e) => {
                            e.preventDefault();
                            handleEditClose(item);}}
                        >
                          <img src={"./../images/cancel.svg"} alt="cancel" width={24} height={24} />
                        </button>
                      </div>
                    )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DocumentCreation;
